import { RANGE_VALUE, RANGE_TYPE } from './constant';
/**
 * 将 range 生成为 data 数据
 * @param range
 * @param key
 */

export function processRangeData(range) {
  return range // 映射为 stack 的数据
  .map(function (r, idx) {
    var _a;

    return _a = {}, _a[RANGE_VALUE] = r - (range[idx - 1] || 0), _a[RANGE_TYPE] = "" + idx, _a;
  }) // 去掉 0 的数据
  .filter(function (d) {
    return !!d[RANGE_VALUE];
  });
}